import React from 'react';
import PropTypes from 'prop-types';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
import { SingleTargetChart, MultiTargetChart, PAChart, PATable } from '.';

export default function Chart({
  advancedMetric = '',
  advancedMetricChartType,
  advancedMetricTargetUnit = '',
  advancedMetricType = '',
  embed = '',
  handsontable = '',
  height = null,
  highChartSetting = '',
  label = '',
  measureResults,
  metricType = 'Image',
  performanceGraphUrl = '',
  showCSVDownload = true,
  singleTargetAggregationFunction = '',
  singleTargetMilestoneDate = '',
  singleTargetTargetAmount = '',
  startOfFinancialYear,
  summaryDetails = '',
  title = '',
  viewType,
}) {
  let chart = '';

  if (metricType === 'OriginalSingle' || (advancedMetric === 'Yes' && advancedMetricType === 'single_target')) {
    chart = (
      <SingleTargetChart
        height={275}
        advancedMetricTargetUnit={advancedMetricTargetUnit}
        measureResults={measureResults}
        singleTargetAggregationFunction={singleTargetAggregationFunction}
        singleTargetMilestoneDate={singleTargetMilestoneDate}
        singleTargetTargetAmount={singleTargetTargetAmount}
        showCSVDownload={showCSVDownload}
        advancedMetric={advancedMetric}
        advancedMetricType={advancedMetricType}
        advancedMetricChartType={advancedMetricChartType}
        title={title}
        label={label}
        viewType={viewType}
        startOfFinancialYear={startOfFinancialYear}
        metricType={metricType}
      />
    );
  } else if (metricType === 'OriginalMulti' || (advancedMetric === 'Yes' && advancedMetricType === 'multiple_target')) {
    chart = (
      <MultiTargetChart
        height={275}
        measureResults={measureResults}
        advancedMetricTargetUnit={advancedMetricTargetUnit}
        showCSVDownload={showCSVDownload}
        advancedMetricChartType={advancedMetricChartType}
        title={title}
      />
    );
  } else if ((metricType === 'Image' || advancedMetric === 'No') && performanceGraphUrl.length > 0) {
    chart = <img src={performanceGraphUrl.replace(/"/g, '')} alt={title} />;
  } else if ((metricType === 'Highcharts' || advancedMetric === 'No') && highChartSetting.length) {
    chart = highChartSetting.length > 5 ? <PAChart height={height} config={highChartSetting} showCSVDownload={showCSVDownload} /> : '';
  } else if ((metricType === 'Handsontable' || advancedMetric === 'No') && handsontable.length) {
    chart = handsontable.length > 5 ? <PATable height={height} config={handsontable} /> : '';
  } else if ((['Summary', 'Embed'].includes(metricType) || advancedMetric === 'No') && (embed.length > 0 || summaryDetails.length > 0)) {
    chart = (
      <div
        style={{
          minHeight: `${height}px`,
          minWidth: '100%',
        }}
      >
        <FroalaEditorView model={JSON.parse(metricType === 'Summary' ? summaryDetails : embed).html.replace("'fa fa", "'fal fa")} />
      </div>
    );
  }

  return chart;
}

Chart.propTypes = {
  height: PropTypes.number,
  measureResults: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advancedMetricTargetUnit: PropTypes.string,
  singleTargetAggregationFunction: PropTypes.string,
  singleTargetMilestoneDate: PropTypes.string,
  singleTargetTargetAmount: PropTypes.string,
  performanceGraphUrl: PropTypes.string,
  embed: PropTypes.string,
  handsontable: PropTypes.string,
  highChartSetting: PropTypes.string,
  showCSVDownload: PropTypes.bool,
  advancedMetric: PropTypes.string,
  advancedMetricType: PropTypes.string,
  advancedMetricChartType: PropTypes.string.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
  viewType: PropTypes.string.isRequired,
  startOfFinancialYear: PropTypes.string.isRequired,
  metricType: PropTypes.string,
  summaryDetails: PropTypes.string,
};
